module.exports = __webpack_public_path__ + "img/410a.266b9037.png";